// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__Q3WlH","content":"LoadingAlert_content__2c8rD"};